import { useNavigate } from 'react-router-dom';

export default function Market() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg-light pb-20">
      {/* Status Bar */}
      <div className="bg-white px-4 py-2 flex items-center justify-between">
        <div className="text-sm font-medium">마켓</div>
        <button className="text-gray-600">
          <i className="fas fa-search text-lg"></i>
        </button>
      </div>

      {/* Header */}
      <div className="bg-white px-4 py-6 mb-2">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">배어링 마켓</h1>
        <p className="text-sm text-gray-600">
          다양한 상품을 만나보세요
        </p>
      </div>

      {/* 카테고리 */}
      <div className="bg-white px-4 py-4 mb-2">
        <div className="grid grid-cols-4 gap-4">
          {[
            { icon: 'fa-tshirt', label: '의류' },
            { icon: 'fa-utensils', label: '식품' },
            { icon: 'fa-home', label: '생활' },
            { icon: 'fa-book', label: '도서' },
            { icon: 'fa-laptop', label: '디지털' },
            { icon: 'fa-spa', label: '뷰티' },
            { icon: 'fa-basketball-ball', label: '스포츠' },
            { icon: 'fa-ellipsis-h', label: '기타' },
          ].map((category) => (
            <button
              key={category.label}
              className="flex flex-col items-center justify-center py-3"
            >
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-2">
                <i className={`fas ${category.icon} text-primary text-lg`}></i>
              </div>
              <span className="text-xs text-gray-700">{category.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* 상품 목록 */}
      <div className="bg-white px-4 py-4">
        <h2 className="text-lg font-bold text-gray-900 mb-4">추천 상품</h2>
        <div className="grid grid-cols-2 gap-4">
          {/* 추후 상품 데이터 연동 예정 */}
          <div className="text-center py-12 text-gray-400 col-span-2">
            <i className="fas fa-shopping-bag text-4xl mb-3"></i>
            <p className="text-sm">준비중입니다</p>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="flex items-center justify-around py-2">
          <button
            onClick={() => navigate('/view/home')}
            className="flex flex-col items-center justify-center py-2 px-4 text-gray-400"
          >
            <i className="fas fa-home text-xl mb-1"></i>
            <span className="text-xs">홈</span>
          </button>
          <button className="flex flex-col items-center justify-center py-2 px-4 text-gray-400">
            <i className="fas fa-cog text-xl mb-1"></i>
            <span className="text-xs">설정</span>
          </button>
          <button className="flex flex-col items-center justify-center py-2 px-4 text-gray-400">
            <i className="fas fa-mug-hot text-xl mb-1"></i>
            <span className="text-xs">카페</span>
          </button>
          <button className="flex flex-col items-center justify-center py-2 px-4 text-primary">
            <i className="fas fa-shopping-bag text-xl mb-1"></i>
            <span className="text-xs font-medium">마켓</span>
          </button>
        </div>
      </div>
    </div>
  );
}
